import { render } from "./archived_shop.vue?vue&type=template&id=dcbb14ea"
import script from "./archived_shop.vue?vue&type=script&lang=js"
export * from "./archived_shop.vue?vue&type=script&lang=js"

import "./archived_shop.vue?vue&type=style&index=0&id=dcbb14ea&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__